import { IMemberType } from "./memberType";

export class INotification {
   _id: string;
   title: string;
   body: string;
   status: string;
   isDelete: boolean;
   scheduleDate: Date;
   recurring: boolean;
   sendingTo: IMemberType[];
   branch: string;
   company: string;
   createdBy: string;
   createdDate: Date;
   modifiedBy: string;
   modifiedDate: Date;
}
